import { render, staticRenderFns } from "./TableCategoryCounter.vue?vue&type=template&id=dbfdbdd0&scoped=true"
import script from "./TableCategoryCounter.vue?vue&type=script&lang=js"
export * from "./TableCategoryCounter.vue?vue&type=script&lang=js"
import style0 from "./TableCategoryCounter.vue?vue&type=style&index=0&id=dbfdbdd0&prod&lang=scss"
import style1 from "./TableCategoryCounter.vue?vue&type=style&index=1&id=dbfdbdd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfdbdd0",
  null
  
)

export default component.exports